// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"AdminLayout_dashboardContainer__oeFyp"};